module.exports = __webpack_public_path__ + "img/sol_cap3.2575726d.png";